export default {
  UNKNOWN: 1,
  INVOICE: 2,
  PENDING_DIVISION_ORDER: 3,
  RUN_STATEMENT: 4,
  DOCUMENT_1099: 5,
  OWNER_STATEMENT: 6,
};
